import React, { PropsWithChildren, Fragment } from "react";
import { EPermissionLevel } from "../../interfaces/ICategoryPermission";
import { useCategoryPermission } from "../../store/selectors/permissionSelectors";

interface IProps {
    categoryId: number;
    permissionType: "read" | "edit" | "create";
    minimumPermission: EPermissionLevel;
    fallback?: JSX.Element;
}

export const MinimumCategoryPermission: React.FC<PropsWithChildren<IProps>> = (props) => {
    const { categoryId, minimumPermission, permissionType, fallback, children } = props;

    const permissionsForCategory = useCategoryPermission(categoryId);
    const permissionLevel = permissionsForCategory[permissionType];

    
    if (permissionLevel >= minimumPermission) {
        return <Fragment>{children}</Fragment>;
    } else {
        return fallback || null;
    }
};
  